<template>
  <div>
    <a-card
      :bordered="false"
      class="header-solid h-full mb-20"
      :bodyStyle="{ paddingTop: '12px' }"
    >
      <template #title>
        <a-row type="flex" align="middle">
          <a-col :span="24" :md="20">
            <h6>How to request an Official Activity Transcript</h6>
            <p>
              Students can receive an official version of the MUIC Activity Transcript for free by completing the online request form at the nearby icon.
            </p>
          </a-col>
          <a-col
            :span="24"
            :md="4"
            style="
              display: flex;
              align-items: center;
              justify-content: flex-end;
            "
          >
            <a-button target="_blank" href="https://goo.gl/forms/1gscoXYzQ2wQuY9t1" block type="primary">
              Request
            </a-button>
          </a-col>
        </a-row>
      </template>
      <!-- components -->
      <div class="mt-0 mb-10">
        <historyclub />
      </div>
      <div class="mt-5 mb-10">
        <historyactivie />
      </div>
    </a-card>
  </div>
</template>

<script>
import historyclub from "./historyclub.vue";
import historyactivie from "./historyactive.vue";
export default {
  components: {
    historyclub,
    historyactivie,
  },
  data() {
    return {};
  },
};
</script>